import React from 'react';
import styled from 'styled-components';

import { TickIcon } from '@components/icons';

const CustomCheckbox = ({ selected, backgroundColor }) => (
    <Checkbox selected={selected} backgroundColor={backgroundColor}>
        {selected && <TickIcon width="10px" height="8px" />}
    </Checkbox>
);

const Checkbox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15px;
    height: 15px;
    min-width: 15px;
    min-height: 15px;
    border: ${({ theme }) => `solid 0.5px ${theme.colors.primary}`};
    background: ${({ selected, theme }) =>
        selected && `${theme.colors.primary}`};
    background-color: ${({ backgroundColor }) =>
        backgroundColor && backgroundColor};
`;

export default CustomCheckbox;
